export const TaskManagementRequiredDictionaries: Set<string> = new Set<string>()
  .add('taskStatuses')
  .add('taskPriorities')
  .add('locations')
  .add('departments')
  .add('responsibleDepartments')
  .add('assignees')
  .add('areas')
  .add('membershipLevels')
  .add('groupStatuses')
  .add('taskTypes')
  .add('taskTags');



// WEBPACK FOOTER //
// ./src/components/TaskManagement/shared/config/taskManagementDictionaries.ts